export enum InvestigationPartyRole {
	Investigator = 1,
	Respondent = 2,
}
